import { Input } from 'components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const SearchBar = ({ text, setText }) => {
  const { isMobile } = useSelector((state) => state.appState),
    { t } = useTranslation();

  return (
    <Input
      search
      value={text}
      onChange={(e) => setText(e.target.value)}
      marg={!isMobile && '0 24px 0 0'}
      wid={isMobile ? 'calc(100% - 52px)' : '296px'}
      placeholder={t('common.search')}
    />
  );
};

export default SearchBar;
